<label class="kp-select">
  <span *ngIf="label" class="kp-select__label" [class.kp-select__label--required]="required">{{ label }}</span>
  <select class="kp-select__select" [attr.name]="name" [formControl]="control" [required]="required">
    <option *ngFor="let option of options; trackBy: trackByValue" [value]="option.value">{{ option.label }}</option>
  </select>
</label>
